import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { TriggerToast } from "../globals/Toaster";
import PageSectionDivider from "../elements/PageSectionDivider";
import IconFont from "../elements/IconFont";
import { appRoutes } from "../../routes/appRoutes";

interface NoWorkspaceProps {
  canCreateWorkspace?: boolean;
}

const NoWorkspace: React.FC<NoWorkspaceProps> = ({ canCreateWorkspace = true }): React.ReactElement => {
  const navigate = useNavigate();

  const handleCreateWorkspaceClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (!canCreateWorkspace) {
      event.preventDefault();
      TriggerToast("Access Denied: Join Waitlist", undefined, 'error');
      return;
    }
    navigate(appRoutes.workspace.create);
  };

  return (
    <div className="w-full">
      <div className="my-[32px] text-center w-full">
        <div className="bg-background-surface-01 rounded-[50%] flex items-center justify-center mx-auto mb-[32px] w-[64px] h-[64px]"><IconFont name="triangle-alert" size={32} /></div>
        <h2 className="type-heading-lg">Workspace Not Found</h2>
      </div>
      <div className="w-full seperator flex items-center gap-[16px] my-[32px]">
        <PageSectionDivider className="my-0 flex-1" />
        <span>OR</span>
        <PageSectionDivider className="my-0 flex-1" />
      </div>
      <div className="no-workspace flex flex-col p-[16px] items-center rounded-[6px] border border-solid border-border-default gap-[8px]">
        <div className="new-workspace__text text-center">
          <h3 className="font-bold text-md">New workspace?</h3>
          <p className="text-sm">Dive into data-driven decisions, refine strategies, and elevate performance.</p>
        </div>
        <div className="no-workspace__link">
          <NavLink
            className="btn-primary"
            to={appRoutes.workspace.create}
            onClick={handleCreateWorkspaceClick}
          >
            Create New Workspace
          </NavLink>
        </div>
      </div>
      <div className="flex items-center justify-center gap-[8px] mt-[16px]">
        <IconFont name="triangle-alert" size={16} className="shrink-0" />
        <div className="text-sm text-body-muted basis-auto">To ensure continued access, please associate your account with a workspace within the next 30 days.</div>
      </div>
    </div>
  )
}

export default NoWorkspace;
